@if (hideShell()) {
  <router-outlet />
} @else {
  @if (notificationPortal()) {
    <div class="fixed bottom-24 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md px-4">
      <ng-template [cdkPortalOutlet]="notificationPortal()" />
    </div>
  }

  <cmi-page-header>
    <a
      headerActions
      routerLink="/settings"
      class="p-1 hover:bg-white/10 rounded transition-colors cursor-pointer"
      [attr.aria-label]="'settings.title' | translate">
      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M7.84 1.804A1 1 0 018.82 1h2.36a1 1 0 01.98.804l.331 1.652a6.993 6.993 0 011.929 1.115l1.598-.54a1 1 0 011.186.447l1.18 2.044a1 1 0 01-.205 1.251l-1.267 1.113a7.047 7.047 0 010 2.228l1.267 1.113a1 1 0 01.206 1.25l-1.18 2.045a1 1 0 01-1.187.447l-1.598-.54a6.993 6.993 0 01-1.929 1.115l-.33 1.652a1 1 0 01-.98.804H8.82a1 1 0 01-.98-.804l-.331-1.652a6.993 6.993 0 01-1.929-1.115l-1.598.54a1 1 0 01-1.186-.447l-1.18-2.044a1 1 0 01.205-1.251l1.267-1.114a7.05 7.05 0 010-2.227L1.821 7.773a1 1 0 01-.206-1.25l1.18-2.045a1 1 0 011.187-.447l1.598.54A6.993 6.993 0 017.51 3.456l.33-1.652zM10 13a3 3 0 100-6 3 3 0 000 6z"
          clip-rule="evenodd" />
      </svg>
    </a>
  </cmi-page-header>

  <div class="p-4 flex-1 overflow-auto">
    <router-outlet />
  </div>

  @if (footerPortal()) {
    <div class="sticky bottom-0 bg-gray-50 p-4">
      <ng-template [cdkPortalOutlet]="footerPortal()" />
    </div>
  }

  @if (propertyFormatPortal()) {
    <div class="p-4 bg-gray-50 border-y border-gray-200">
      <ng-template [cdkPortalOutlet]="propertyFormatPortal()" />
    </div>
  }

  @if (reportsFormatContentControlId()) {
    <div class="p-4 bg-gray-50 border-y border-gray-200">
      <cmi-reports-format [contentControlId]="reportsFormatContentControlId()!" />
    </div>
  }

  @if (showTableOptions()) {
    <div class="p-4 bg-gray-50 border-y border-gray-200">
      <cmi-table-options [contentControlId]="tableOptionsContentControlId()!" />
    </div>
  }
}

<ng-template #propertyFormatTemplate>
  <cmi-property-format [contentControlId]="propertyFormatContentControlId()!" />
</ng-template>
